import { MenuItem } from '@material-ui/core';
import React from 'react';
import _ from 'lodash';

import FormSelectRedesign from 'retired/FormSelectRedesign';
import { AffiliationType } from 'generated/graphql';

export const AffiliationTypeSelector = ({ ...props }): JSX.Element => {
  const affiliationTypes = Object.values(AffiliationType).map((type) => _.startCase(type));

  return (
    <FormSelectRedesign {...props}>
      {affiliationTypes.map((affiliation) => (
        <MenuItem key={affiliation} value={affiliation}>
          {affiliation}
        </MenuItem>
      ))}
    </FormSelectRedesign>
  );
};

export default AffiliationTypeSelector;
